import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { GoogleOAuthProvider } from '@react-oauth/google';

import { AppProviders } from 'src/app/providers';
import { ExtensionProvider } from 'src/lib/extension/extension-context';

import App from './App';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <StrictMode>
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <ExtensionProvider>
        <AppProviders>
          <Suspense>
            <App />
          </Suspense>
        </AppProviders>
      </ExtensionProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
  // </StrictMode>
);
